<ion-card mode="ios" class="card-table-data" padding>

    <ng-container *ngIf="version" [ngSwitch]="selectedLanguage">
        <ion-item>
            <ion-label position="stacked">
                {{ 'manageVersion.versionName' | translate }} *
            </ion-label>
            <ion-input type="text"
                       [(ngModel)]="version.versionName"
            ></ion-input>
        </ion-item>
    </ng-container>
    <div class="lang-title">
        <h2>
            <ion-text color="primary">
                {{ 'manageVersion.configureMultilanguage' | translate }}
            </ion-text>
        </h2>
        <div class="lang-selection">
            <ion-button fill="clear" mode="ios" class="ion-no-padding"
                        (click)="changeSelectedLanguage('pt-BR')"
                        [ngClass]="{ 'active': selectedLanguage === 'pt-BR' }">
                PT
            </ion-button>
            <ion-button fill="clear" mode="ios" class="ion-no-padding"
                        (click)="changeSelectedLanguage('en-US')"
                        [ngClass]="{ 'active': selectedLanguage === 'en-US' }">
                EN
            </ion-button>
            <ion-button fill="clear" mode="ios" class="ion-no-padding"
                        (click)="changeSelectedLanguage('es-ES')"
                        [ngClass]="{ 'active': selectedLanguage === 'es-ES' }">
                ES
            </ion-button>
        </div>
    </div>

    <ng-container *ngIf="version" [ngSwitch]="selectedLanguage">
        <div padding-bottom>
            <app-process-configuration
                    *ngSwitchCase="'pt-BR'"
                    [configuration]="version.globalizationConfig['pt-BR']"
            ></app-process-configuration>

            <app-process-configuration
                    *ngSwitchCase="'en-US'"
                    [configuration]="version.globalizationConfig['en-US']"
            ></app-process-configuration>

            <app-process-configuration
                    *ngSwitchCase="'es-ES'"
                    [configuration]="version.globalizationConfig['es-ES']"
            ></app-process-configuration>
        </div>
    </ng-container>
</ion-card>

<ion-footer>
    <ion-row>
        <div class="action-buttons">
            <ion-button
                    align-items-center
                    mode="ios"
                    color="danger"
                    id="cancelButton"
                    (click)="dismissModal()"
            >
                {{ 'generic.cancel' | translate }}
            </ion-button>
            <ion-button
                    align-items-center
                    mode="ios"
                    color="primary"
                    id="saveGoalButton"
                    (click)="saveVersionConfig(isSelection)"
            >
                {{ 'generic.save' | translate }}
            </ion-button>
        </div>
    </ion-row>
</ion-footer>